"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const auth_1 = require("pages/auth");
const silo_1 = require("pages/silo");
const app_reducer_1 = __importDefault(require("pages/app.reducer"));
const hopper_1 = require("pages/hopper");
const report_1 = require("pages/report");
const silo_pos_1 = require("pages/silo-pos");
const stockpile_1 = require("pages/stockpile");
const dashboard_1 = require("pages/dashboard");
const hopper_pos_1 = require("pages/hopper-pos");
const adjustment_1 = require("pages/adjustment");
const cctv_center_1 = require("pages/cctv-center");
const user_access_1 = require("pages/user-access");
const master_data_1 = require("pages/master-data");
const daily_summary_1 = require("pages/daily-summary");
const stockpile_pos_1 = require("pages/stockpile-pos");
const configuration_1 = require("pages/configuration");
const coal_chain_simulation_report_1 = require("pages/coal-chain-simulation-report");
const bg_loading_transshipment_1 = require("pages/bg-loading-transshipment");
const store = (0, redux_1.combineReducers)({
    app: app_reducer_1.default,
    auth: auth_1.authReducer,
    silo: silo_1.siloReducer,
    hopper: hopper_1.hopperReducer,
    report: report_1.reportReducer,
    siloPos: silo_pos_1.siloPosReducer,
    master: master_data_1.masterDataReducer,
    stockpile: stockpile_1.stockpileReducer,
    hopperPos: hopper_pos_1.hopperPosReducer,
    dashboard: dashboard_1.dashboardReducer,
    adjustment: adjustment_1.adjustmentReducer,
    cctvCenter: cctv_center_1.cctvCenterReducer,
    userAccess: user_access_1.userAccessReducer,
    simulation: coal_chain_simulation_report_1.simulationReducer,
    dailySummary: daily_summary_1.dailySummaryReducer,
    stockpilePos: stockpile_pos_1.stockpilePosReducer,
    configuration: configuration_1.configurationReducer,
    bgLoadingTransshipment: bg_loading_transshipment_1.bgLoadingTransshipmentReducer,
});
exports.default = store;
